/**
 * plugins/vuetify.ts
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
import '@mdi/font/css/materialdesignicons.css'
import '@/styles/data-table.scss'
import 'vuetify/styles'

// Composables
import { createVuetify, type ThemeDefinition } from 'vuetify'
import { fr, en } from 'vuetify/locale'
import { userLocale } from './app-internationalization/i18n'

// Theme (copied from SPA)
const ubiLight: ThemeDefinition = {
    dark: false,
    colors: {
        // Primary
        'primary-lighten-2': '#9CA6FF',
        'primary-lighten-1': '#5E54FF',
        primary: '#3321A1',
        'primary-darken-1': '#31258A',
        'primary-darken-2': '#1F1650',

        // Success
        'success-lighten-2': '#C8E6C9',
        'success-lighten-1': '#81C784',
        success: '#2E7D32',
        'success-darken': '#126018',

        // Warning
        'warning-lighten-3': '#FFF3E0',
        'warning-lighten-2': '#FFD180',
        'warning-lighten-1': '#FFAB40',
        warning: '#FF9100',
        'warning-darken': '#FF6D00',

        // Error
        'error-lighten-3': '#FFEBEE',
        'error-lighten-2': '#EEC6BE',
        'error-lighten-1': '#EC6560',
        error: '#C7241D',
        'error-darken': '#B71C1C',

        // Info
        'info-lighten-2': '#58A7F8',
        'info-lighten-1': '#0C6FF9',
        info: '#0850FD',
        'info-darken': '#00206F',

        // neutal
        'neutral-100': '#F5F5F5',
        'neutral-200': '#EEEEEE',
        'neutral-300': '#E0E0E0',
        'neutral-500': '#9E9E9E',
        'neutral-700': '#616161',
        'neutral-900': '#1B1A20',

        // others
        background: '#F8F9FD',
        surface: '#FFFFFF',
    },
}

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
    locale: {
        locale: userLocale.value,
        fallback: 'fr-FR',
        messages: {
            'fr-FR': fr,
            'en-US': en,
        },
    },
    theme: {
        defaultTheme: 'ubiLight',
        themes: {
            ubiLight,
        },
    },
    defaults: {
        VAlert: {
            variant: 'outlined',
            border: 'start',
        },
        VAutocomplete: {
            variant: 'outlined',
            density: 'compact',
            hideDetails: 'auto',
        },
        VBtn: {
            class: 'text-none',
            color: 'primary',
            elevation: 0,
            rounded: 'lg',
        },
        VCheckbox: {
            hideDetails: 'auto',
            color: 'info-lighten-2',
            density: 'compact',
        },
        VDataTable: {
            class: 'data-table',
            itemsPerPageOptions: [10, 20, 50],
        },
        VDataTableServer: {
            class: 'data-table',
            itemsPerPageOptions: [10, 20, 50],
        },
        VField: {
            color: 'primary',
            variant: 'outlined',
        },
        VProgressCircular: {
            color: 'primary',
            indeterminate: true,
        },
        VSelect: {
            variant: 'outlined',
            density: 'compact',
            hideDetails: 'auto',
        },
        VTextarea: {
            density: 'compact',
            hideDetails: 'auto',
            rounded: 'lg',
            variant: 'outlined',
        },
        VTextField: {
            density: 'compact',
            hideDetails: 'auto',
            rounded: 'lg',
            variant: 'outlined',
        },
        VNumberInput: {
            density: 'compact',
            hideDetails: 'auto',
            rounded: 'lg',
            variant: 'outlined',
            controlVariant: 'stacked',
            VBtn: {
                color: 'default',
            },
        },
        VSwitch: {
            color: 'primary',
            inset: true,
            hideDetails: 'auto',
            density: 'compact',
        },
    },
})
